import { ADD_REGISTRATION } from "./types";

let initialState = {
    registrations: [],
};

const registrationReducer = (state = initialState,action) => {
    switch (action.type) {
        case ADD_REGISTRATION:
            return {
                ...state,
                registrations: [...state.registrations, action.payload]
            };
        default:
            return state;
    }
}

export default registrationReducer;